import { render, staticRenderFns } from "./TjingToggle.vue?vue&type=template&id=56ad55be&scoped=true"
import script from "./TjingToggle.vue?vue&type=script&lang=js"
export * from "./TjingToggle.vue?vue&type=script&lang=js"
import style0 from "./TjingToggle.vue?vue&type=style&index=0&id=56ad55be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ad55be",
  null
  
)

export default component.exports